/* HanaHub「私の大好きな秘密の未来の宝箱」— 気になる商品の handle をこのブラウザに保存する */
(function () {
  var KEY = 'hanahub_treasure';
  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* 保存できない環境では何もしない */ }
    document.dispatchEvent(new CustomEvent('hanahub:treasure', { detail: list }));
  }
  var T = {
    list: read,
    has: function (h) { return read().indexOf(h) !== -1; },
    toggle: function (h) {
      var l = read(), i = l.indexOf(h);
      if (i === -1) l.unshift(h); else l.splice(i, 1);
      write(l);
      return i === -1;
    },
    remove: function (h) { write(read().filter(function (x) { return x !== h; })); },
    yen: function (n) { return '¥' + Number(n).toLocaleString('ja-JP'); },
    /* data-hh-treasure="handle" のボタンを ♡ トグルにする */
    bind: function (root) {
      (root || document).querySelectorAll('[data-hh-treasure]').forEach(function (b) {
        if (b.dataset.hhBound) return;
        b.dataset.hhBound = '1';
        var paint = function () {
          var on = T.has(b.dataset.hhTreasure);
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          var label = b.querySelector('[data-hh-label]');
          if (label) label.textContent = on ? (b.dataset.on || '宝箱に入っています') : (b.dataset.off || '未来の宝箱に入れる');
        };
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          T.toggle(b.dataset.hhTreasure);
        });
        document.addEventListener('hanahub:treasure', paint);
        paint();
      });
    }
  };
  window.HHTreasure = T;
  document.addEventListener('DOMContentLoaded', function () { T.bind(); });
})();
